import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { editorMessages } from '../messages/editorMessages';
import { panelMessages } from '../messages/panelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The cuts of the song, newest first (design d4: "Cuts" are the versions). A click opens one. */
const CutsListComponent: React.FC = () => {
  const intl = useIntl();
  const { data, cutUuid, openCut } = useMusicVideoEditor();
  const cuts = useMemo(() => [...data.cuts].sort((a, b) => b.number - a.number), [data.cuts]);
  return (
    <>
      <span className={styles.eyebrow}>{intl.formatMessage(panelMessages.cutsEyebrow)}</span>
      <div className={styles.column}>
        {cuts.map((cut) => (
          <button
            key={cut.uuid}
            type="button"
            className={clsx(styles.cutRow, cut.uuid === cutUuid && styles.cutRowOn)}
            aria-current={cut.uuid === cutUuid}
            onClick={() => openCut(cut.uuid)}
          >
            <span className={styles.cutThumb}>{cut.number}</span>
            {intl.formatMessage(panelMessages.cutRow, { number: cut.number })}
            {cut.madeAssetUuid !== null && ` · ${intl.formatMessage(editorMessages.cutItemMade)}`}
            <small>{intl.formatTime(cut.updatedAt, { hour: '2-digit', minute: '2-digit' })}</small>
          </button>
        ))}
      </div>
    </>
  );
};

export const CutsList = TypedMemo(CutsListComponent);
